import React from 'react';
import { LocalString, Plural, Money } from 'translate-react';
import { togglePanel } from '../actions';

let BookingColumns = (props, context) => {
	let { open } = props;

	return (
		<div style={{height:'100%'}}>
			<div className="accordion-col accordion-col12">

			</div>
			<div className="accordion-col accordion-col3">
			</div>
			<div className="accordion-col accordion-col4">
				{!open ? 
				<button onClick={(e) => context.store.dispatch(togglePanel("booking"))}>
					<LocalString word="Ändern" />
				</button>
				: null}
			</div>
		</div>
	);
};
BookingColumns.contextTypes = { store: React.PropTypes.object };

export default BookingColumns;



/** WEBPACK FOOTER **
 ** ../ibe/desktop/BookingColumns.js
 **/